(function () {
  var root = document.querySelector("[data-scheduled-sale-root]");
  if (!root) return;

  var state = {
    products: [],
    filter: "all",
    page: 1,
    pageSize: Number(root.getAttribute("data-page-size")) || 24
  };

  function parseCollections() {
    var node = root.querySelector("[data-ssm-collections]");
    if (!node) return [];
    try {
      return JSON.parse(node.textContent || "[]").filter(function (item) {
        return item && item.handle && Number(item.discount) > 0;
      });
    } catch (error) {
      return [];
    }
  }

  function cents(value) {
    return Math.round(Number(value || 0) * 100);
  }

  function money(value) {
    return "Rs. " + (value / 100).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  function escapeHtml(value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function productHasCompareAtDiscount(product) {
    return (product.variants || []).some(function (variant) {
      return variant.available && cents(variant.compare_at_price) > cents(variant.price);
    });
  }

  function getPriceRange(product) {
    var variants = (product.variants || []).filter(function (variant) {
      return variant.available;
    });
    if (!variants.length) variants = product.variants || [];

    var prices = variants.map(function (variant) {
      return cents(variant.price);
    }).filter(function (price) {
      return price > 0;
    });

    if (!prices.length) prices = [cents(product.variants && product.variants[0] && product.variants[0].price)];
    var min = Math.min.apply(Math, prices);
    var max = Math.max.apply(Math, prices);
    return { min: min, max: max };
  }

  function getDiscountedPrice(price, discount) {
    return price - Math.floor(price * discount / 100);
  }

  function getProductImage(product) {
    if (product.images && product.images.length && product.images[0].src) return product.images[0].src;
    if (product.image && product.image.src) return product.image.src;
    return "";
  }

  function renderPrice(product) {
    var range = getPriceRange(product);
    var discount = Number(product.ssmDiscount) || 0;
    var minSale = getDiscountedPrice(range.min, discount);
    var maxSale = getDiscountedPrice(range.max, discount);
    var minSave = range.min - minSale;
    var maxSave = range.max - maxSale;
    var hasRange = range.max > range.min;

    if (hasRange) {
      return '<span class="ssm-price" data-ssm-price><del>' + money(range.min) + " - " + money(range.max) + "</del><ins>" + money(minSale) + " - " + money(maxSale) + '</ins><span class="ssm-price__save">Save ' + money(minSave) + " - " + money(maxSave) + "</span></span>";
    }
    return '<span class="ssm-price" data-ssm-price><del>' + money(range.min) + "</del><ins>" + money(minSale) + '</ins><span class="ssm-price__save">Save ' + money(minSave) + "</span></span>";
  }

  function renderProduct(product) {
    var image = getProductImage(product);
    var title = escapeHtml(product.title);
    var discount = Number(product.ssmDiscount) || 0;
    var handle = encodeURIComponent(product.handle);
    return [
      '<article class="ssm-card col-lg-3 col-md-3 col-6 mt__30 pr_grid_item product nt_pr" data-ssm-product data-ssm-discount="' + discount + '">',
      '<div class="product-inner pr">',
      '<a class="ssm-card__image product-image pr oh" href="/products/' + handle + '" aria-label="' + title + '">',
      image ? '<img src="' + escapeHtml(image) + '" alt="' + title + '" loading="lazy">' : "",
      '<span class="ssm-card__badge ssm-card__badge--top_left">' + discount + "% OFF</span>",
      product.available === false ? '<span class="ssm-card__soldout nt_label out-of-stock">Sold out</span>' : "",
      "</a>",
      '<div class="product-info mt__15">',
      '<h3 class="product-title pr fs__14 mg__0 fwm"><a class="cd chp" href="/products/' + handle + '">' + title + "</a></h3>",
      renderPrice(product),
      "</div>",
      "</div>",
      "</article>"
    ].join("");
  }

  async function fetchCollectionProducts(collection) {
    var products = [];
    var page = 1;
    while (page <= 20) {
      var response = await fetch("/collections/" + encodeURIComponent(collection.handle) + "/products.json?limit=250&page=" + page, {
        credentials: "same-origin"
      });
      if (!response.ok) break;
      var data = await response.json();
      var batch = data.products || [];
      if (!batch.length) break;
      batch.forEach(function (product) {
        product.ssmDiscount = Number(collection.discount);
        product.ssmCollectionTitle = collection.title;
      });
      products = products.concat(batch);
      if (batch.length < 250) break;
      page += 1;
    }
    return products;
  }

  function mergeProducts(collectionProducts) {
    var byId = {};
    collectionProducts.forEach(function (product) {
      if (productHasCompareAtDiscount(product)) return;
      var existing = byId[product.id];
      if (!existing || Number(product.ssmDiscount) > Number(existing.ssmDiscount)) {
        byId[product.id] = product;
      }
    });
    return Object.keys(byId).map(function (id) {
      return byId[id];
    });
  }

  function filteredProducts() {
    if (state.filter === "all") return state.products;
    return state.products.filter(function (product) {
      return String(product.ssmDiscount) === state.filter;
    });
  }

  function updateCounts() {
    var counts = root.querySelector("[data-ssm-product-counts]");
    if (!counts) return;
    var visible = filteredProducts().length;
    counts.innerHTML = "<span>" + visible + " products shown</span><span>" + state.products.length + " total sale products loaded</span>";
  }

  function renderFilters(collections) {
    var holder = root.querySelector("[data-ssm-discount-filters]");
    if (!holder) return;
    var discounts = [];
    collections.forEach(function (collection) {
      var discount = String(Number(collection.discount));
      if (discounts.indexOf(discount) === -1) discounts.push(discount);
    });
    discounts.sort(function (a, b) {
      return Number(a) - Number(b);
    });

    holder.innerHTML = ['<button type="button" class="ssm-filter" data-ssm-discount-filter="all" aria-selected="true">All</button>']
      .concat(discounts.map(function (discount) {
        return '<button type="button" class="ssm-filter" data-ssm-discount-filter="' + discount + '" aria-selected="false">' + discount + "% OFF</button>";
      })).join("");
    holder.hidden = false;

    holder.querySelectorAll("[data-ssm-discount-filter]").forEach(function (button) {
      button.addEventListener("click", function () {
        holder.querySelectorAll("[data-ssm-discount-filter]").forEach(function (filterButton) {
          filterButton.setAttribute("aria-selected", String(filterButton === button));
        });
        state.filter = button.getAttribute("data-ssm-discount-filter") || "all";
        state.page = 1;
        renderGrid();
      });
    });
  }

  function renderPagination(total) {
    var holder = root.querySelector("[data-ssm-pagination]");
    if (!holder) return;
    var pages = Math.ceil(total / state.pageSize);
    if (pages <= 1) {
      holder.hidden = true;
      holder.innerHTML = "";
      return;
    }

    var html = "";
    if (state.page > 1) html += '<button type="button" class="ssm-pagination__link" data-ssm-page="' + (state.page - 1) + '">Previous</button>';
    for (var page = 1; page <= pages; page += 1) {
      html += '<button type="button" class="ssm-pagination__link' + (page === state.page ? " is-active" : "") + '" data-ssm-page="' + page + '">' + page + "</button>";
    }
    if (state.page < pages) html += '<button type="button" class="ssm-pagination__link" data-ssm-page="' + (state.page + 1) + '">Next</button>';
    holder.innerHTML = html;
    holder.hidden = false;
    holder.querySelectorAll("[data-ssm-page]").forEach(function (button) {
      button.addEventListener("click", function () {
        state.page = Number(button.getAttribute("data-ssm-page")) || 1;
        renderGrid();
        root.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    });
  }

  function renderGrid() {
    var grid = root.querySelector("[data-ssm-grid]");
    var empty = root.querySelector("[data-ssm-empty]");
    if (!grid) return;
    var products = filteredProducts();
    var total = products.length;
    var start = (state.page - 1) * state.pageSize;
    var pageProducts = products.slice(start, start + state.pageSize);
    grid.innerHTML = pageProducts.map(renderProduct).join("");
    if (empty) empty.hidden = total !== 0;
    updateCounts();
    renderPagination(total);
  }

  async function loadSaleProducts() {
    var collections = parseCollections();
    if (!collections.length || root.getAttribute("data-sale-state") !== "live") return;
    renderFilters(collections);
    var grid = root.querySelector("[data-ssm-grid]");
    if (grid) grid.innerHTML = '<div class="col-12 tc mt__30 mb__30">Loading sale products...</div>';
    var batches = await Promise.all(collections.map(fetchCollectionProducts));
    state.products = mergeProducts([].concat.apply([], batches));
    renderGrid();
  }

  function formatDuration(seconds) {
    if (seconds <= 0) return "00:00:00";
    var days = Math.floor(seconds / 86400);
    var hours = Math.floor((seconds % 86400) / 3600);
    var minutes = Math.floor((seconds % 3600) / 60);
    var secs = seconds % 60;
    var time = [hours, minutes, secs].map(function (value) {
      return String(value).padStart(2, "0");
    }).join(":");
    return days > 0 ? days + "d " + time : time;
  }

  function updateCountdown() {
    var countdown = root.querySelector("[data-ssm-countdown]");
    if (!countdown) return;
    var value = countdown.querySelector("[data-ssm-countdown-value]");
    var target = Number(countdown.getAttribute("data-target-epoch")) || 0;
    if (!value || !target) return;
    var now = Math.floor(Date.now() / 1000);
    value.textContent = formatDuration(target - now);
  }

  function updateDiagnostics() {
    var diagnostic = root.querySelector("[data-ssm-current-ist]");
    if (!diagnostic) return;
    var formatter = new Intl.DateTimeFormat("en-IN", {
      timeZone: "Asia/Kolkata",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false
    });
    diagnostic.textContent = "Current IST: " + formatter.format(new Date()) + " (Asia/Kolkata)";
  }

  function scheduleStateRefresh() {
    var saleState = root.getAttribute("data-sale-state");
    var target = 0;
    if (saleState === "pre_sale") {
      target = Number(root.getAttribute("data-live-sale-epoch")) || 0;
    } else if (saleState === "live") {
      target = Number(root.getAttribute("data-sale-end-epoch")) || 0;
    }
    if (!target) return;
    var now = Math.floor(Date.now() / 1000);
    var delay = (target - now + 2) * 1000;
    if (delay <= 0 || delay > 2147483647) return;
    window.setTimeout(function () {
      window.location.reload();
    }, delay);
  }

  updateDiagnostics();
  updateCountdown();
  scheduleStateRefresh();
  loadSaleProducts();
  if (root.querySelector("[data-ssm-countdown]")) {
    window.setInterval(updateCountdown, 1000);
  }
})();
